import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { ZorroTableComponent } from '../../../components/common/custom-table/zorro-table.component';
import { SharedComponents } from '../../../components/shared.module';
import { ProjectService } from '../../../core/services/project/project.service';
import { RestService } from '../../../core/services/rest.service';
import { ToasterService } from '../../../core/services/toaster-service';
import { testPlanningColumns } from '../../../core/table-templates/test-planning-table';
import { MessageEnum } from '../../../core/utils/message.enum';
import { AddOrEditTestPlanComponent } from '../add-or-edit-test-plan/add-or-edit-test-plan.component';

@Component({
  selector: 'app-test-planning',
  standalone: true,
  imports: [MatIconModule,SharedComponents,CommonModule],
  templateUrl: './test-planning.component.html',
  styleUrl: './test-planning.component.scss'
})
export class TestPlanningComponent implements OnInit{
  @ViewChild(ZorroTableComponent) zorroTableComponent!: ZorroTableComponent;
  private modalService = inject(NgbModal);
  private messageService = inject(MessageService);
  columns = testPlanningColumns;
  dataSource:any = [];
  options = {
    isExpandable: false,
  };
  projectId: any;
  automationProjectId: any;
  selectedRows:any = [];
  isDataLoaded=false;

  constructor(
    private restService : RestService,
    private projectService: ProjectService,
    private readonly toaster: ToasterService
  ){
    this.projectService.getProjectId().subscribe((id) => {
      this.projectId = id;
    });
    this.projectService.getAutomationProjectId().subscribe((id: any) => {
      this.automationProjectId = id;
    });
  }

  ngOnInit(): void {
    this.fetchTableData();
  }

  fetchTableData(){
    this.restService.getTestPlans(this.projectId,this.automationProjectId).subscribe((response)=>{
      let data = response.data;
      let row;
      this.dataSource = [];
      for(let i=0;i<data.length;i++){
        row= data[i];
        this.dataSource = [...this.dataSource,{
          id:row.id,
          plan_no: i+1,
          plan_name: row.name,
          count: `${row.testScripts.length} Test Case(s)`,
          date:row.date || "N/A",
          edit:"",
          select:false
        }];
      }
      this.zorroTableComponent?.refreshTableData();
      this.isDataLoaded= true;
    },(error)=>{
      this.toaster.pop({ type: 'error', text: MessageEnum.TEST_PLAN_LOAD_FAILURE });
      this.isDataLoaded= true;
    });
  }

  addOrRemoveTestPlan(type:String){
    if(type == "+"){
      const modalRef = this.modalService.open(AddOrEditTestPlanComponent, {
        centered: false,
        windowClass: "test-plan-modal",
        backdrop: 'static',
      });
      modalRef.componentInstance.data = {
        title : "Add New Test Plan"
      };
      modalRef.componentInstance.testPlansList = this.dataSource;
      modalRef.result.then((result) => {
        this.isDataLoaded = false;
        this.fetchTableData();
      });
    } else if(type == '-') {
      if(!this.selectedRows.length){
        this.toaster.pop({ type: 'error', text: MessageEnum.DATA_SELECTION_NONE });
      }
      this.restService.deletTestPlansById(this.projectId, this.automationProjectId,this.selectedRows).subscribe(
        (respose)=>{
          this.toaster.pop({ type: 'success', text: MessageEnum.TEST_PLAN_DELETE_SUCCESS });
          this.isDataLoaded = false;
          this.selectedRows = [];
          this.fetchTableData();
        },
        (error)=>{
          this.toaster.pop({ type: 'error', text: MessageEnum.TEST_PLAN_DELETE_FAILURE });
        });
    }
    
  }
  handleActionsInTable(event: any) {
    let rowId = event.data.row.id;
    let action = event.data.column.key;
    switch(action){
      case 'edit':
        const modalRef = this.modalService.open(AddOrEditTestPlanComponent, {
          centered: false,
          windowClass: "test-plan-modal",
          backdrop: 'static',
        });
        modalRef.componentInstance.data = {
          title : "Edit New Test Plan",
          id:rowId,
        };
        modalRef.componentInstance.testPlansList = this.dataSource;
        modalRef.result.then((result) => {
          this.isDataLoaded = false;
          this.fetchTableData();
        });
        break;
    }
  }

  handleSelect(event: any){
    this.selectedRows= [];
    event.data.forEach((row:any)=> this.selectedRows.push(row.id) )
  }
}
